import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import { useCardImage } from './useCardImage'
import { InformationModal } from 'shared/components/modals/InformationModal'

import appConfig from 'app.config'

import { ICreditBalance } from 'selfServicePortal/interfaces/i-api-creaditCard'
import { appRoutes } from 'selfServicePortal/constants/routes'
import { menuItems } from 'selfServicePortal/constants/menuItems'
import {
	checkIsMobile,
	checkIsTablet,
	getCurrency,
	stringifyNum,
} from 'shared/index'

import './CardOverview.scss'
import { IInformationModalProps } from 'shared/interfaces/i-api-informationModal'
import { useSspContext } from 'selfServicePortal/hooks/useSspContext'

const CardImg = () => {
	const img = useCardImage()
	const { isMarketing } = useSspContext()

	if (isMarketing?.imageLink) {
		return (
			<a href={isMarketing.imageLink}>
				<img src={img} alt="card" />
			</a>
		)
	}
	return <img src={img} alt="card" />
}

const Card = () => {
	return (
		<div className="fade-in-card tfbank-card-container cards d-flex justify-content-center">
			<div className="imageContainer">
				<CardImg />
			</div>
		</div>
	)
}
interface IInfoBox {
	overviewData: ICreditBalance
	fullDate: string
	name: string
	cardNr: string
}
const InfoBox = ({ overviewData, fullDate, name, cardNr }: IInfoBox) => {
	const { t } = useTranslation()
	const isMobile = checkIsMobile()
	const isTablet = checkIsTablet()

	return (
		<div
			className={`${
				isTablet ? 'tablet-overview' : ''
			} overview d-flex flex-column p-3`}>
			<div className="inner-box p-3">
				<div className="d-flex justify-content-between">
					<div className="d-flex flex-column">
						<div className="mb-4 name">{name}</div>
						<div className="light small">{t('FreeAmount')}</div>
						<div className="amount">
							{stringifyNum(overviewData?.availableCreditAmount, {
								currency: getCurrency(),
								style: 'currency',
							})}
						</div>
					</div>
					<div className="d-flex flex-column text-right">
						<div className="light">{t('ExpiryDate')}</div>
						<div>{fullDate}</div>
						{appConfig.country === 'no' && !isMobile && (
							<div className="mt-4 amount">{cardNr}</div>
						)}
					</div>
				</div>
				{appConfig.country === 'no' && isMobile && (
					<div className="mt-4 amount">{cardNr}</div>
				)}
			</div>
			<div className="box-below d-flex justify-content-between p-3">
				<div className="light d-flex flex-column">
					<div className="py-1">{t('CreditCardLimit')}</div>
					<div className="py-1">{t('ReservedAmount')}</div>
					<div className="py-1">{t('Balance')}</div>
				</div>
				<div className="d-flex flex-column text-right">
					<div className="py-1">
						{stringifyNum(overviewData?.creditLimit, {
							currency: getCurrency(),
							style: 'currency',
						})}
					</div>
					<div className="py-1">
						{stringifyNum(overviewData?.reservedAmount, {
							currency: getCurrency(),
							style: 'currency',
						})}
					</div>
					<div className="py-1">
						{appConfig.country === 'no' &&
						overviewData?.availableCreditAmount >
							overviewData?.creditLimit
							? 'kr 0,00'
							: stringifyNum(overviewData?.balance, {
									currency: getCurrency(),
									style: 'currency',
							  })}
					</div>
				</div>
			</div>
		</div>
	)
}

const CardOverview = () => {
	const isMobile = checkIsMobile()
	const isTablet = checkIsTablet()
	const location = useLocation()
	const {
		overviewData,
		customerData,
		error,
		setComponent,
		hadleCloseInformationModal,
		hasCustomerSeenInformationModal,
		informationModalData,
	} = useSspContext()
	const [creditCardData, setCreditCardData] = useState(
		overviewData as ICreditBalance,
	)

	useEffect(() => {
		setCreditCardData(overviewData as ICreditBalance)
	}, [overviewData])

	let date =
		creditCardData?.cardExpirationDate !== undefined
			? (
					'0' +
					(new Date(creditCardData?.cardExpirationDate!).getMonth() +
						1)
			  ).slice(-2)
			: ''

	let year =
		creditCardData?.cardExpirationDate !== undefined
			? new Date(creditCardData?.cardExpirationDate!)
					.getFullYear()
					.toString()
					.substring(2)
			: ''

	let fullDate =
		creditCardData?.cardExpirationDate !== undefined
			? `${date}/${year}`
			: ''

	let cardNr =
		creditCardData?.creditCardNo !== undefined
			? creditCardData?.creditCardNo.slice(0, 4) +
			  ' ' +
			  creditCardData?.creditCardNo.slice(4, 8) +
			  ' ' +
			  creditCardData?.creditCardNo.slice(8, 12) +
			  ' ' +
			  creditCardData?.creditCardNo.slice(12, 16)
			: ''

	useEffect(
		() => {
			if (location.pathname === appRoutes.referfriends) {
				setComponent(menuItems[0].items[5])
			}
		},
		[], //eslint-disable-line
	)

	return (
		<>
			{!error && (
				<>
					<div className="fade-in container d-flex pt-4">
						{location.pathname === appRoutes.referfriends ? null : (
							<InformationModal
								content={
									informationModalData?.find(
										(item) =>
											item.active &&
											item.country === appConfig.country,
									) as IInformationModalProps
								}
								onClose={() => hadleCloseInformationModal()}
								show={!hasCustomerSeenInformationModal}
							/>
						)}
						<InfoBox
							overviewData={overviewData! as ICreditBalance}
							fullDate={fullDate}
							name={`${customerData?.firstName} ${customerData?.lastName}`}
							cardNr={cardNr}
						/>
						{!isMobile ||
						(isTablet &&
							window.innerWidth > 991 &&
							window.innerHeight > 991) ? (
							<Card />
						) : (
							<></>
						)}
					</div>
				</>
			)}
		</>
	)
}
export default CardOverview
